/**
 * Current operational scope for feedback and student roster.
 * Prior academic years remain in the DB for reports/history only.
 */
export const OPERATIONAL_ACADEMIC_YEAR = '2026-2027';
export const OPERATIONAL_ODD_SEMESTERS = [1, 3, 5, 7];

export function divisionAcademicYear(d) {
  return d?.academic_year ?? d?.academicYear ?? '';
}

export function divisionDegreeId(d) {
  return d?.degree_id ?? d?.degreeId ?? '';
}

export function isOperationalDivision(division) {
  const ay = divisionAcademicYear(division);
  const sem = Number(division?.semester);
  return ay === OPERATIONAL_ACADEMIC_YEAR && OPERATIONAL_ODD_SEMESTERS.includes(sem);
}

export function filterOperationalDivisions(divisions) {
  return (divisions || []).filter(isOperationalDivision);
}

export function filterOperationalSemesters(semesters) {
  const set = new Set(OPERATIONAL_ODD_SEMESTERS);
  return (semesters || []).filter((s) => set.has(Number(s)));
}
